import {Button, Col, FormGroup, Row} from "reactstrap";
import {I18n} from "../../I18n/components/promoter";
import React from "react";

const ModalButtonsRow = props => {
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup className="d-md-flex justify-content-end">
                    <Button
                        color="secondary"
                        onClick={props.onCancelClick}>
                        {I18n[props.lang].modal.cancel}
                    </Button>
                    <Button
                        color="primary"
                        type="submit"
                        className="ml-1"
                        disabled={props.isSaveDisable}>
                        {props.isSaveDisable ? <i className="mr-2 fa fa-spinner fa-spin"/> : null} {I18n[props.lang].modal.save}
                    </Button>
                </FormGroup>
            </Col>
        </Row>
    )
}

export default ModalButtonsRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/ModalButtonsRow.js